import { ScheduleTelevisit } from "src/app/database-models/schedule-televisit";


export class ScheduleTelevisitLookupGroup {
	scheduleTelevisit : ScheduleTelevisit;
}
